import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import SearchDataGrid from 'components/search/search-data-grid/search-data-grid.component';
import { DateTime } from 'luxon';
import PercentDeliveredChip from 'pages/analytics/sms-reports/percent-delivered-chip/percent-delivered-chip.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

const MarketingDataGrid = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'communication',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.communication',
        ),
        hideable: false,
        minWidth: 220,
        flex: 2,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.communication}</Typography>,
      },
      {
        field: 'communicationType',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.communicationType',
        ),
        hideable: false,
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => (
          <Typography>{row?.communicationType}</Typography>
        ),
      },
      {
        field: 'startDate',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.startDate',
        ),
        minWidth: 120,
        flex: 1,
        valueGetter: (_value, row) => {
          return DateTime.fromISO(row?.startDate).toLocaleString(
            DateTime.DATETIME_MED,
          );
        },
      },
      {
        field: 'endDate',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.endDate',
        ),
        minWidth: 120,
        flex: 1,
        valueGetter: (_value, row) => {
          const endDate = row?.endDate;
          return endDate
            ? DateTime.fromISO(endDate).toLocaleString(DateTime.DATETIME_MED)
            : '';
        },
      },
      {
        field: 'smsSent',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.smsSent',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.smsSent}</Typography>,
      },
      {
        field: 'smsDelivered',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.smsDelivered',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.smsDelivered}</Typography>,
      },
      {
        field: 'percentDelivered',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.percentDelivered',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => (
          <PercentDeliveredChip score={row?.percentDelivered} />
        ),
      },
      {
        field: 'segmentsSent',
        headerName: t(
          'page.reportAndAnalytics.smsReports.sections.marketing.grid.segmentsSent',
        ),
        minWidth: 120,
        flex: 1,
        display: 'flex',
        renderCell: ({ row }) => <Typography>{row?.segmentsSent}</Typography>,
      },
    ],
    [t],
  );

  return (
    <SearchDataGrid
      columns={columns}
      getRowId={() => uuidv4()}
      data-testid="Marketing.DataGrid"
    />
  );
};

export default MarketingDataGrid;
